<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">修改</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">
                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="24" class="item">
                                <el-form-item label="图标" required >
                                    <el-upload
                                    class="upload-demo"
                                        :action="uploadUrl"
                                        list-type="picture-card"
                                        :data='uploadData'
                                        :show-file-list="false"
                                        :on-success="handleImgSuccess"
                                        style="width:100%;margin-top:40px">
                                        <img v-if="editForm.icon" :src="editForm.icon" fit='cover'  class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="名称" required prop="name">
                                    <el-input v-model="editForm.name" placeholder="请输入名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="排序" required prop="sort">
                                    <el-input v-model.number="editForm.sort" placeholder="请输入排序"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="活动分类状态" required prop="status">
                                    <el-select v-model="editForm.status" placeholder="请选择状态" @change="changeStatus" style="width:100%">
                                        <el-option
                                                v-for="item in status2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: 'Edit',
        props:['attributeList'],
        data() {
            return {
                loading: false,
                iconDialog: false,
                uploadUrl:this.$shopUrl+'Upload/Imgs',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    name:'',
                    articleClassCode:'',
                    staffCode:getStaffCode(),
                    parentArticleClassCode:'',
                    sort:'',
                    icon:'',
                    status:0,
                },
                status2: [{
                    value: 1,
                    label: '正常'
                }, {
                    value: 2,
                    label: '禁用'
                }],
                rules:{
                    name:[
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入排序', trigger: 'blur' },
                        { type: 'number', message: '排序必须为数字值'}
                    ],
                    isGroup:[
                        { required: true, message: '请选择是否团购', trigger: 'blur' },
                    ],
                    goodsAttributeCodeList:[
                        { required: true, message: '请选择属性', trigger: 'blur' },
                    ]

                }

            }
        },
        methods: {
            init(row){
                this.editForm.articleClassCode = row.articleClassCode;
                this.editForm.parentArticleClassCode = row.parentArticleClassCode;
                this.editForm.name = row.name;
                this.editForm.sort = row.sort;
                this.editForm.status = row.status;
                this.editForm.icon = this.$imgUrl+row.icon;
            },
            closeSelf() {
                this.$emit("closeEdit");
            },
            handleImgSuccess(res) {
                this.editForm.icon = this.$imgUrl+res.data.path;
            },
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        if(!this.editForm.icon){
                            this.$message({type: 'warning', message: '请上传商品图标'});
                            return;
                        }
                        this.addSubmit();
                    }else {
                        
                        return false;
                    }
                })
            },
            changeStatus:function (selVal) {
                this.editForm.status = selVal;
            },
            iconPreview() {
                this.iconDialog = true;
            },
            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.editForm.icon=this.editForm.icon.replace(this.$imgUrl,'')
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"ArticleClass/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },

        }
    }

</script>

